import FormattedMessage from 'I18n/components/FormattedMessage';
import { H1 } from 'UIComponents/elements/headings';
import UIBox from 'UIComponents/layout/UIBox';
import styled from 'styled-components';
import { getProductLineFromApiNameString } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import { HubProductHeader } from '../../HubProductHeader';
import TrialUpgradePageMerchCard from './TrialUpgradePageMerchCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledSubtitle = styled.p.withConfig({
  displayName: "TrialUpgradeBannerContent__StyledSubtitle",
  componentId: "sc-1lnggsq-0"
})(["max-width:30vw;min-width:30vw;"]);
export const TrialUpgradeBannerContent = ({
  apiName
}) => {
  const productLine = getProductLineFromApiNameString(apiName);
  const i18nKey = `interstitial.hc0119.upgradeToProfessional.${productLine.toLowerCase()}`;
  return /*#__PURE__*/_jsxs(UIBox, {
    grow: 1,
    basis: "50%",
    className: "p-x-4",
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(HubProductHeader, {
        apiName: apiName
      }), /*#__PURE__*/_jsx(H1, {
        className: "m-bottom-10",
        "aria-level": 1,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${i18nKey}.title`
        })
      }), /*#__PURE__*/_jsx(StyledSubtitle, {
        className: "text-left",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${i18nKey}.body`
        })
      })]
    }), /*#__PURE__*/_jsx(TrialUpgradePageMerchCard, {
      apiName: apiName,
      productLine: productLine
    })]
  });
};